setPmSectionAction